let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bv26F")).then(() => parcelRequire('9zGp3'));